/**
 * 艦載機熟練度ボーダー
 * @static
 * @memberof Const
 */
export const PROF_LEVEL_BORDER = [0, 10, 25, 40, 55, 70, 85, 100, 120];

/**
 * 補強増設を識別するindex
 * @static
 * @memberof Const
 */
export const EXPAND_SLOT_INDEX = 99;

/**
 * 実装最大レベル
 * @static
 * @memberof Const
 */
export const MAX_LEVEL = 188;

/**
 * 1つ前の実装最大レベル フィルタ補正用
 * @static
 * @memberof Const
 */
export const PREVIOUS_MAX_LEVEL = 185;

/**
 * 経験値最低値ボーダー
 * @static
 * @memberof Const
 */
export const LEVEL_BORDERS = [
  { lv: 188, req: 20200000 },
  { lv: 187, req: 18600000 },
  { lv: 186, req: 17200000 },
  { lv: 185, req: 16000000 },
  { lv: 184, req: 15000000 },
  { lv: 183, req: 14200000 },
  { lv: 182, req: 13600000 },
  { lv: 181, req: 13200000 },
  { lv: 180, req: 13000000 },
  { lv: 179, req: 12100000 },
  { lv: 178, req: 11600000 },
  { lv: 177, req: 11300000 },
  { lv: 176, req: 11100000 },
  { lv: 175, req: 10950000 },
  { lv: 174, req: 10266000 },
  { lv: 173, req: 9705000 },
  { lv: 172, req: 9248000 },
  { lv: 171, req: 8875000 },
  { lv: 170, req: 8580000 },
  { lv: 169, req: 8350000 },
  { lv: 168, req: 8172000 },
  { lv: 167, req: 8033000 },
  { lv: 166, req: 7920000 },
  { lv: 165, req: 7820000 },
  { lv: 164, req: 7320000 },
  { lv: 163, req: 6910000 },
  { lv: 162, req: 6580000 },
  { lv: 161, req: 6320000 },
  { lv: 160, req: 6120000 },
  { lv: 159, req: 5970000 },
  { lv: 158, req: 5860000 },
  { lv: 157, req: 5780000 },
  { lv: 156, req: 5720000 },
  { lv: 155, req: 5470000 },
  { lv: 154, req: 5230000 },
  { lv: 153, req: 4999000 },
  { lv: 152, req: 4777000 },
  { lv: 151, req: 4564000 },
  { lv: 150, req: 4360000 },
  { lv: 149, req: 4165000 },
  { lv: 148, req: 3978000 },
  { lv: 147, req: 3799000 },
  { lv: 146, req: 3628000 },
  { lv: 145, req: 3465000 },
  { lv: 144, req: 3310000 },
  { lv: 143, req: 3162000 },
  { lv: 142, req: 3021000 },
  { lv: 141, req: 2887000 },
  { lv: 140, req: 2760000 },
  { lv: 139, req: 2640000 },
  { lv: 138, req: 2525000 },
  { lv: 137, req: 2415000 },
  { lv: 136, req: 2310000 },
  { lv: 135, req: 2210000 },
  { lv: 134, req: 2115000 },
  { lv: 133, req: 2025000 },
  { lv: 132, req: 1940000 },
  { lv: 131, req: 1860000 },
  { lv: 130, req: 1785000 },
  { lv: 129, req: 1714000 },
  { lv: 128, req: 1647000 },
  { lv: 127, req: 1584000 },
  { lv: 126, req: 1525000 },
  { lv: 125, req: 1470000 },
  { lv: 124, req: 1419000 },
  { lv: 123, req: 1372000 },
  { lv: 122, req: 1329000 },
  { lv: 121, req: 1290000 },
  { lv: 120, req: 1255000 },
  { lv: 119, req: 1223000 },
  { lv: 118, req: 1194000 },
  { lv: 117, req: 1168000 },
  { lv: 116, req: 1145000 },
  { lv: 115, req: 1125000 },
  { lv: 114, req: 1107000 },
  { lv: 113, req: 1091000 },
  { lv: 112, req: 1077000 },
  { lv: 111, req: 1065000 },
  { lv: 110, req: 1055000 },
  { lv: 109, req: 1046000 },
  { lv: 108, req: 1038000 },
  { lv: 107, req: 1031000 },
  { lv: 106, req: 1025000 },
  { lv: 105, req: 1020000 },
  { lv: 104, req: 1016000 },
  { lv: 103, req: 1013000 },
  { lv: 102, req: 1011000 },
  { lv: 101, req: 1010000 },
  { lv: 100, req: 1000000 },
  { lv: 99, req: 1000000 },
  { lv: 98, req: 851500 },
  { lv: 97, req: 761500 },
  { lv: 96, req: 701500 },
  { lv: 95, req: 661500 },
  { lv: 94, req: 631500 },
  { lv: 93, req: 606500 },
  { lv: 92, req: 584500 },
  { lv: 91, req: 564500 },
  { lv: 90, req: 545500 },
  { lv: 89, req: 527000 },
  { lv: 88, req: 509000 },
  { lv: 87, req: 491500 },
  { lv: 86, req: 474500 },
  { lv: 85, req: 458000 },
  { lv: 84, req: 442000 },
  { lv: 83, req: 426500 },
  { lv: 82, req: 411500 },
  { lv: 81, req: 397000 },
  { lv: 80, req: 383000 },
  { lv: 79, req: 369400 },
  { lv: 78, req: 356200 },
  { lv: 77, req: 343400 },
  { lv: 76, req: 331000 },
  { lv: 75, req: 319000 },
  { lv: 74, req: 307400 },
  { lv: 73, req: 296200 },
  { lv: 72, req: 285400 },
  { lv: 71, req: 275000 },
  { lv: 70, req: 265000 },
  { lv: 69, req: 255300 },
  { lv: 68, req: 245900 },
  { lv: 67, req: 236800 },
  { lv: 66, req: 228000 },
  { lv: 65, req: 219500 },
  { lv: 64, req: 211300 },
  { lv: 63, req: 203400 },
  { lv: 62, req: 195800 },
  { lv: 61, req: 188500 },
  { lv: 60, req: 181500 },
  { lv: 59, req: 174700 },
  { lv: 58, req: 168100 },
  { lv: 57, req: 161700 },
  { lv: 56, req: 155500 },
  { lv: 55, req: 149500 },
  { lv: 54, req: 143700 },
  { lv: 53, req: 138100 },
  { lv: 52, req: 132700 },
  { lv: 51, req: 127500 },
  { lv: 50, req: 122500 },
  { lv: 49, req: 117600 },
  { lv: 48, req: 112800 },
  { lv: 47, req: 108100 },
  { lv: 46, req: 103500 },
  { lv: 45, req: 99000 },
  { lv: 44, req: 94600 },
  { lv: 43, req: 90300 },
  { lv: 42, req: 86100 },
  { lv: 41, req: 82000 },
  { lv: 40, req: 78000 },
  { lv: 39, req: 74100 },
  { lv: 38, req: 70300 },
  { lv: 37, req: 66600 },
  { lv: 36, req: 63000 },
  { lv: 35, req: 59500 },
  { lv: 34, req: 56100 },
  { lv: 33, req: 52800 },
  { lv: 32, req: 49600 },
  { lv: 31, req: 46500 },
  { lv: 30, req: 43500 },
  { lv: 29, req: 40600 },
  { lv: 28, req: 37800 },
  { lv: 27, req: 35100 },
  { lv: 26, req: 32500 },
  { lv: 25, req: 30000 },
  { lv: 24, req: 27600 },
  { lv: 23, req: 25300 },
  { lv: 22, req: 23100 },
  { lv: 21, req: 21000 },
  { lv: 20, req: 19000 },
  { lv: 19, req: 17100 },
  { lv: 18, req: 15300 },
  { lv: 17, req: 13600 },
  { lv: 16, req: 12000 },
  { lv: 15, req: 10500 },
  { lv: 14, req: 9100 },
  { lv: 13, req: 7800 },
  { lv: 12, req: 6600 },
  { lv: 11, req: 5500 },
  { lv: 10, req: 4500 },
  { lv: 9, req: 3600 },
  { lv: 8, req: 2800 },
  { lv: 7, req: 2100 },
  { lv: 6, req: 1500 },
  { lv: 5, req: 1000 },
  { lv: 4, req: 600 },
  { lv: 3, req: 300 },
  { lv: 2, req: 100 },
  { lv: 1, req: 0 },
];
